var map = {
	"./en/btn-1-active.png": "ZtyD",
	"./en/btn-2-active.png": "f8N0",
	"./media-active.png": "QbWN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "u+ls";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5 ^\.\/.*\-active\.png$
// module id = u+ls
// module chunks = 0